'use client'

//import {ProductBrowser} from '@ecwid/nextjs-ecwid-plugin'

import { getGlobalData } from "../utils/api"
import Seo from "../components/elements/seo"
import Head from "next/head"
import ProductBrowser from "../components/ecwid/extended-product-browser"
import Link from "next/link"
import Script from "next/script"
import { useEffect, useState } from "react"

const StorePage = ({ global, metadata }) => {
    const [ecwidPage, setEcwidPage] = useState(null)

    const metadataWithDefaults = {
        ...global.metadata,
        ...metadata,
    }
    //const canonicalHref = metadataWithDefaults.canonicalURL
    const isProductPage = ecwidPage?.type === "PRODUCT"
    const productTitle = ecwidPage?.productName || ecwidPage?.name || "Product Details"

useEffect(() => {
    const intro = document.getElementById("bt-store-intro");
    if (!intro) return;
    const ctaStyleId = "bt-ecwid-force-white-cta-text";

    const ensureCtaTextStyles = () => {
      let styleEl = document.getElementById(ctaStyleId);
      if (styleEl) return;

      styleEl = document.createElement("style");
      styleEl.id = ctaStyleId;
      styleEl.textContent = `
        .ec-store .ecwid-btn--primary,
        .ec-store .ecwid-btn--primary *,
        .ec-size .ec-store .form-control--primary .form-control__button,
        .ec-size .ec-store .form-control--primary .form-control__button *,
        .ec-size .ec-store .grid-product__buy-now .form-control__button,
        .ec-size .ec-store .grid-product__buy-now .form-control__button *,
        .ec-store .details-product-purchase .form-control__button--primary,
        .ec-store .details-product-purchase .form-control__button--primary *,
        .ec-store .details-product-purchase .details-product-purchase__add-to-bag,
        .ec-store .details-product-purchase .details-product-purchase__add-to-bag *,
        .ec-store .details-product-purchase .details-product-purchase__buy-now,
        .ec-store .details-product-purchase .details-product-purchase__buy-now *,
        .ec-store .form-control--primary .form-control__button:hover,
        .ec-store .form-control--primary .form-control__button:hover *,
        .ec-store .grid-product__buy-now .form-control__button:hover,
        .ec-store .grid-product__buy-now .form-control__button:hover * {
          color: #fff !important;
          fill: #fff !important;
        }
      `;
      document.head.appendChild(styleEl);
    };

    const setVisibility = () => {
      const path = window.location.pathname || "";
      const hash = window.location.hash || "";
      const currentRoute = `${path}${hash}`;
      const isCartOrCheckout =
        /\/store\/(cart|checkout)/.test(currentRoute) ||
        /#!\/(?:cart|checkout)/.test(currentRoute);
      const isProductPage =
        /-p\d+/.test(currentRoute) ||
        /\/product\//.test(currentRoute) ||
        /#!\/.+-p\d+/.test(currentRoute);

      intro.style.display = isCartOrCheckout ? "none" : "";
      intro.classList.toggle("bt-store-intro--compact", isProductPage);
      document.body.classList.toggle("bt-ecwid-product-page", isProductPage);
    };

    ensureCtaTextStyles();
    // Run once on load
    setVisibility();

    // Ecwid SPA navigation: listen to hash/path changes
    window.addEventListener("popstate", setVisibility);
    window.addEventListener("hashchange", setVisibility);

    // Also poll briefly after Ecwid initializes (covers in-app navigation that doesn't trigger popstate)
    const t = window.setInterval(setVisibility, 250);

    return () => {
      window.removeEventListener("popstate", setVisibility);
      window.removeEventListener("hashchange", setVisibility);
      intro.classList.remove("bt-store-intro--compact");
      document.body.classList.remove("bt-ecwid-product-page");
      const styleEl = document.getElementById(ctaStyleId);
      if (styleEl) styleEl.remove();
      window.clearInterval(t);
    };
  }, []);

    return (<>
        <Head>
            {/* <title>{metadataWithDefaults.metaTitle || metadata.metaTitle}</title>
            <meta name="description" content={metadataWithDefaults.metaDescription || metadata.metaDescription} />
            <link rel="canonical" href={metadataWithDefaults.canonicalURL || metadata.canonicalURL} />
            <meta property="og:title" content={metadataWithDefaults.metaTitle || metadata.metaTitle} />
            <meta property="og:description" content={metadataWithDefaults.metaDescription || metadata.metaDescription} />
            <meta property="og:url" content={metadataWithDefaults.canonicalURL || metadata.canonicalURL} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={metadataWithDefaults.metaImage || metadata.metaImage} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metadataWithDefaults.metaTitle || metadata.metaTitle} />
            <meta name="twitter:description" content={metadataWithDefaults.metaDescription || metadata.metaDescription} />
            <meta name="twitter:image" content={metadataWithDefaults.metaImage || metadata.metaImage} /> */}
            {/* <link rel="icon" href="/favicon.ico" /> */}
            {/* <link rel="apple-touch-icon" href="/apple-touch-icon.png" /> */}
            <link rel="manifest" href="/manifest.json" />
            <meta name="theme-color" content="#ffffff" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="index, follow" />
            <link rel="preconnect" href="https://fonts.googleapis.com" />``
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            {/* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@400;500;600;700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700&display=swap" rel="stylesheet" /> */}
            {/* <link href="https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&display=swap" rel="stylesheet" /> */}
            {/* <link href="https://fonts.googleapis.com/css2?family=PT+Sans:wght@400;600;700&display=swap" rel="stylesheet" />                     */}
            {/* <script defer src="https://app.helpfulcrowd.com/f/8XS9k1/widgets/product_rating.js"></script> */}

           

                 
        </Head>
         <Script id="_s3" 
       // nonce={nonce}
        strategy='lazyOnload'
        type="text/javascript" 
        src="https://app.helpfulcrowd.com/f/8XS9k1/widgets/product_rating.js"></Script>
        
        <Seo metadata={metadataWithDefaults} />
    
        <section id="bt-store-intro" className="mx-auto w-full max-w-4xl px-4 pb-4 pt-3 sm:px-6 sm:pb-6 sm:pt-4">
            <div className="bt-store-intro-card rounded-2xl border border-sunrise/40 bg-white/80 px-4 py-4 shadow-sm">
              {/* {!isProductPage && (
                <p className="bt-store-kicker text-[0.7rem] font-bold uppercase tracking-[0.08em] text-chocolate/75 sm:text-xs">
                  Browned & Toasted
                </p>
              )} */}
              <h1 className="bt-store-title mt-1 text-balance text-2xl font-black leading-tight text-crimson sm:text-4xl">
                {isProductPage ? productTitle : "Shop Goldmallow™ Bars"}
              </h1>

              {!isProductPage && (
                <p className="bt-store-lede mt-2 text-sm font-semibold leading-snug text-chocolate sm:text-lg">
                  Whipped for softneess. Toasted for depth. Browned for a finish that lingers.
                  <br/><br/>
                  New here? Start with the <Link href="/store/Goldmallow-Crispy-Assortment-6-Pack-p746961114">Assortment</Link>.
                </p>
              )}

              <div className="bt-store-meta mt-3 flex flex-wrap items-center gap-2 text-xs font-semibold sm:text-sm">
                <span className="rounded-full bg-[#ffedd0] px-3 py-1 text-chocolate">
                  Free shipping on orders over $60
                </span>
                {/* <Link className="underline decoration-chocolate/50 underline-offset-2 hover:decoration-chocolate" href="/catering">
                  Catering
                </Link> */}
                <Link className="underline decoration-chocolate/50 underline-offset-2 hover:decoration-chocolate" href="/wholesale">
                  Looking for wholesale?
                </Link>
              </div>
            </div>
        </section>
        <div className="bt-store-browser mx-auto w-full px-4 pb-6 sm:px-6 lg:px-8">
          <ProductBrowser onPageChange={setEcwidPage} storeId="100774270" />
        </div>
    </>
    )
}

export async function getStaticProps(context) {
    const { params, locale, locales, defaultLocale } = context
    const globalData = await getGlobalData(locale)

    const pageContext = {
        locale,
        locales,
        defaultLocale,
        //      localizations,
    }

    let metadata = {
        //  metaTitle: `See Browned & Toasted Marshmallow Crispy Bars and Bites`,
        //  metaDescription: `Our menu of pull-apart soft marshmallow crispy bars, available for shipping, anywhere`,
        //canonicalURL: `https://brownedandtoasted.com/store`,
    }

    let preview = context.preview || false
    //  const localizedPaths = getLocalizedPaths(pageContext)

    // fetch the available bars
    try {
        return (
            {
                props: {
                    globalData,
                    metadata,
                    pageContext: pageContext,
                    locale,
                    preview: preview,
                },
            }
        )
    } catch (error) {
        return {
            revalidate: 60,
            props: {
                locale,
                error: 500
            }
        }
    }
}


export default StorePage
